import { ApplicationStore } from "src/store";
import { Condition } from "Types/TradeIn";

export const getTradeInEstimate = (state: ApplicationStore) => {
    switch (state.tradeIn.condition) {
        case Condition.Low:
            return state.tradeIn.tp_tradein_low ?? 0;
        case Condition.Target:
            return state.tradeIn.tp_tradein_target ?? 0;
        case Condition.High:
            return state.tradeIn.tp_tradein_high ?? 0;
        default:
            return state.tradeIn.customer_estimate ?? 0;
    }
};

export const getYearMakeModelTrim = (state: ApplicationStore) => state.tradeIn.ymmt ?? null;
